export default __webpack_public_path__ + "static/media/image.auteurs-diaries.64dec121.png";